import LandingB from 'components/LandingB/LandingB';

export const props: GameLessonProps = {
    buckets: {
        hidden: true,
    },
    costs: {
        hidden: true,
    },
    reset: true,
};

export default function Home() {
    return <LandingB />;
}
